/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CloudConnectorUserModule
 */

import {
    Component,
    Input,
} from '@angular/core';
import { NsxtCredentialsConfigItem } from 'ajs/modules/cloud-connector-user';

import { L10nService } from '@vmw/ngx-vip';
import * as l10n from './nsxt-credentials.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for the NsxtCredentials configuration.
 * @author alextsg
 */
@Component({
    selector: 'nsxt-credentials',
    templateUrl: './nsxt-credentials.component.html',
})
export class NsxtCredentialsComponent {
    /**
     * NsxtCredentialsConfigItem Config Item.
     */
    @Input() public editable: NsxtCredentialsConfigItem;

    /**
     * Get keys from source bundles for template usage
     */
    public readonly l10nKeys = l10nKeys;

    public constructor(
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
